import { render, staticRenderFns } from "./GifFooter.vue?vue&type=template&id=4c5a273e&scoped=true&"
import script from "./GifFooter.vue?vue&type=script&setup=true&lang=ts&"
export * from "./GifFooter.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./GifFooter.vue?vue&type=style&index=0&id=4c5a273e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5a273e",
  null
  
)

export default component.exports